import { render } from "./TableQR.vue?vue&type=template&id=208f99c2&scoped=true"
import script from "./TableQR.vue?vue&type=script&lang=js"
export * from "./TableQR.vue?vue&type=script&lang=js"

import "./TableQR.vue?vue&type=style&index=0&id=208f99c2&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-208f99c2"]])

export default __exports__